import styled from 'styled-components';
import { colors, fonts, media } from '../../../utils';

export const Question = styled.div`

`;
